import AuthProvider from '@/providers/auth';
import CookieProvider from '@/providers/cookie';
import EventProvider from '@/providers/event';
import HttpProvider from '@/providers/http';
import LocalStorageProvider from '@/providers/local-storage';
import ModelProvider from '@/providers/model';
import ModuleProvider from '@/providers/module';
import ResourceProvider from "@/providers/resource";
import RouterProvider from '@/providers/router';
import StoreProvider from '@/providers/store';
import VueProvider from '@/providers/vue';
import SectionProvider from '@/providers/section';
import keyValueProvider from '@/providers/key-value';

export default {
    providers: [
        AuthProvider,
        EventProvider,
        HttpProvider,
        LocalStorageProvider,
        ModelProvider,
        ModuleProvider,
        RouterProvider,
        ResourceProvider,
        StoreProvider,
        VueProvider,
        CookieProvider,
        SectionProvider,
        keyValueProvider,
    ]
};
